module.exports = __webpack_public_path__ + "img/icons B_17.7e4c2aea.png";